<template>
  <a-card title="Profil Kerja Praktek">
    <a-button slot="extra" @click="handleModalEdit()"
      v-if="getAuth.divisi[0] == 'HRD' && data.profile.status=='Aktif'"
    >Ubah Data</a-button>
    <a-row>
      <!-- <a-alert
        v-if="data.notif_wa == '1'"
        class="m-bottom"
        message="Anda bersedia menerima pesan notifikasi melalui whatsapp."
      >
      </a-alert> -->
      <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
        <div class="m-bottom">
          <h4 class="m-remove">Jenis Identitas</h4>
          <span class="m-text-light">{{ data.profile.jenis_identitas }}</span>
        </div>
        <div class="m-bottom">
          <h4 class="m-remove">Nomor Identitas</h4>
          <span class="m-text-light">{{ data.profile.nomor_identitas }}</span>
        </div>
        <div class="m-bottom">
          <h4 class="m-remove">Alamat</h4>
          <span class="m-text-light">{{ data.profile.alamat }}</span>
        </div>
        <div class="m-bottom">
          <h4 class="m-remove">No.Telp.</h4>
          <span class="m-text-light">{{ data.profile.no_telp&&data.profile.no_telp!=''?'+'+data.profile.no_telp:'-' }}</span>
        </div>
      </a-col>
      <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
        <div class="m-bottom">
          <h4 class="m-remove">Tempat Lahir</h4>
          <span class="m-text-light">{{ data.profile.tempat_lahir }}</span>
        </div>
        <div class="m-bottom">
          <h4 class="m-remove">Tanggal Lahir</h4>
          <span class="m-text-light">{{ data.profile.tanggal_lahir?moment(data.profile.tanggal_lahir).format("DD-MM-YYYY"):"-" }}</span>
        </div>
        <div class="m-bottom">
          <h4 class="m-remove">Jenis Kelamin</h4>
          <span class="m-text-light">{{ data.profile.jenis_kelamin=='L' ? 'Laki-Laki' : (data.profile.jenis_kelamin=='P' ? 'Perempuan':'-') }}</span>
        </div>
        <div class="m-bottom">
          <h4 class="m-remove">Email</h4>
          <span class="m-text-light">{{ data.profile.email?data.profile.email:'-' }}</span>
        </div>
      </a-col>
    </a-row>

    <a-modal
      :width="800"
      title="Edit Profil"
      :visible="visible"
      @cancel="handleCancel"
    >
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
        <a-button
          key="submit"
          type="primary"
          :loading="btnLoading"
          @click="handleOk"
          >Submit</a-button
        >
      </template>
      <a-form class="m-form" :form="form">
        <a-row :gutter="8">
          <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
            <a-form-item label="Nama Lengkap">
              <a-input
                autocomplete="off"
                v-decorator="[
                  'nama_lengkap',
                  {
                    rules: [{ required: true }],
                    initialValue: data.profile.nama_lengkap,
                  },
                ]"
              />
            </a-form-item>
            <a-form-item label="Jenis Identitas">
              <a-select
                :disabled="getAuth.divisi[0] !== 'HRD'"
                v-decorator="[
                  'jenis_identitas',
                  {
                    rules: [{ required: true }],
                    initialValue: data.profile.jenis_no,
                  },
                ]"
                v-if="data.master"
              >
              <a-select-option
                v-for="item in data.master.jenis_identitas"
                :key="item.value"
              >
                {{ item.text }}
              </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="Nomor Identitas">
              <a-input
                autocomplete="off"
                v-decorator="[
                  'nomor_identitas',
                  {
                    rules: [{ required: true }],
                    initialValue: data.profile.nomor_identitas,
                  },
                ]"
              />
            </a-form-item>
            <a-form-item label="Alamat">
              <a-input
                :disabled="getAuth.divisi[0] !== 'HRD'"
                autocomplete="off"
                v-decorator="[
                  'alamat',
                  {
                    rules: [{ required: true }],
                    initialValue: data.profile.alamat,
                  },
                ]"
              />
            </a-form-item>
            <a-form-item label="No. Telp">
              <a-input
                autocomplete="off"
                v-decorator="[
                  'noTelp',
                  {
                    rules: [{ required: false }],
                    initialValue: getformattelp(data.profile.no_telp),
                  },
                ]"
                @keydown="onlyNumber"
              >
                <a-select
                  slot="addonBefore"
                  v-decorator="[
                    'noTelp_code',
                    {
                      initialValue: getformatCountrytelp(data.profile.no_telp),
                    },
                  ]"
                  style="width: 70px"
                >
                  <a-select-option key="62" value="62">+62</a-select-option>
                  <a-select-option key="61" value="61">+61</a-select-option>
                </a-select>
              </a-input>
            </a-form-item>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
            <a-form-item label="Tempat Lahir">
              <a-input
                autocomplete="off"
                v-decorator="[
                  'tempat_lahir',
                  {
                    rules: [{ required: true }],
                    initialValue: data.profile.tempat_lahir,
                  },
                ]"
              />
            </a-form-item>
            <a-form-item label="Tanggal Lahir">
              <a-date-picker
                class="w-full"
                v-decorator="[
                  'tanggal_lahir',
                  { rules: [{ required: true }], initialValue: data.profile.tanggal_lahir },
                ]"
                format="DD-MM-YYYY"
              />
            </a-form-item>
            <a-form-item label="Jenis Kelamin">
              <a-select
                :disabled="getAuth.divisi[0] !== 'HRD'"
                v-decorator="[
                  'jenis_kelamin',
                  {
                    rules: [{ required: true }],
                    initialValue: data.profile.jenis_kelamin,
                  },
                ]"
              > 
              <a-select-option v-for="item in data.master.jenis_kelamin" :key="item.value">{{item.text}}</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="Email">
              <a-input
                :disabled="getAuth.divisi[0] !== 'HRD'"
                autocomplete="off"
                v-decorator="[
                  'email',
                  {
                    rules: [
                      {
                        type: 'email',
                        message: 'The input is not valid E-mail!',
                      },
                      { required: false },
                    ],
                    initialValue: data.profile.email,
                  },
                ]"
              />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
  </a-card>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import axios from "axios";

export default {
  name: "profile-page",
  props: ["data"],
  data() {
    return {
      visible: false,
      btnLoading: false,
      confirmWa: false,
      tanggungan: [],
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  computed: {
    ...mapGetters(["getAuth", "getDefaultDateFormat"]),
  },
  methods: {
    moment,
    formatNumberTelp() {
      let countryCode = this.data.country_code_tlp
        ? "+" + this.data.country_code_tlp
        : "+62";
      let no = this.data.no_telp ? this.data.no_telp : "-";
      if (no.substring(0, 1) === "0") {
        no = no.substring(1, no.length);
      }
      if (no !== "-") {
        no = countryCode + " " + no;
      }
      return no;
    },
    formatNumberWA() {
      let countryCode = this.data.country_code_wa
        ? "+" + this.data.country_code_wa
        : "+62";
      let no = this.data.no_wa ? this.data.no_wa : "-";
      if (no.substring(0, 1) === "0") {
        no = no.substring(1, no.length);
      }
      if (no !== "-") {
        no = countryCode + " " + no;
      }
      return no;
    },
    handleModalEdit() {
      this.visible = true;
      this.form.setFieldsValue({ 
        tanggungan: this.data.tanggungan 
      });
    },
    handleCancel() {
      this.form.resetFields();
      this.visible = false;
    },
    handleOk() {
      this.form.validateFields((err) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        this.confirmMessage("confirm-edit");
      });
    },
    submit() {
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }

        const postProfile = {
          id_siswa:this.data.profile.id_siswa,
          nama_lengkap:values.nama_lengkap,
          alamat:values.alamat,
          no_telp:(values.noTelp?values.noTelp_code+values.noTelp:''),
          tempat_lahir:values.tempat_lahir,
          tanggal_lahir:this.moment(values.tanggal_lahir).format('YYYY-MM-DD'),
          nomor_identitas:values.nomor_identitas,
          jenis_identitas:values.jenis_identitas,
          jenis_kelamin:values.jenis_kelamin,
          email:values.email,
        };

        this.btnLoading = true;
        axios({
          method: "post",
          url: this.$serviceUrl + "internship/profil",
          processData: false,
          data: postProfile,
          auth: {
            username: this.getAuth.username,
            password: this.getAuth.password,
          },
          headers: {
            "Content-Type": "application/json",
            "X-API-KEY": this.getAuth.apikey,
          },
        })
          .then((response) => {
            Event.$emit("fetching");
            this.displayMessage("success-edit");
            this.btnLoading = false;
            this.visible = false
          })
          .catch((err) => {
            this.btnLoading = false;
          });
      });
    },
    handleConfirmWA(e) {
      this.confirmWa = e.target.checked;
    },
    validatePhone(rule, value, callback) {
      if (/^(\d)+$/.test(value)) {
        callback();
      } else {
        callback(new Error("Mobile number only digits"));
      }
    },
    getformatCountrytelp(val){
      let res = ""
      if(val && val.length>=2){
        res = val.substring(0, 2);
      }
      return res
    },
    getformattelp(val){
      let res = ""
      if(val && val.length>2){
        res = val.substring(2);
      }
      return res
    }
  },
  mounted() {
    Event.$on("confirmMessageEdit", this.submit);
  },
  beforeDestroy() {
    Event.$off("confirmMessageEdit", this.submit);
  },
};
</script>

<style lang="less" scoped>
.confirmWa {
  border: 1px dashed orange;
  background-color: darken(white, 2);
  padding: 0 @padding;
  display: flex;
  align-items: center;
  flex-direction: column;

  > label {
    margin-left: -18px;
  }

  > .ant-input-group-wrapper {
    margin-bottom: @padding;
  }
}
</style>
